import { v4 } from "uuid";

export const kokaMenuCoffe = [
	{
		menuId: v4(),
		menuName: "Caffe Latte",
		menuPrice: "IDR 16k",
		menuAddition: ["Original", "Hazelnut", "Rum", "Vanilla", "Caramel"],
		menuImage: require("./MenusImage/CaffeLatte.png"),
		menuColor: "#ddb892",
	},
	{
		menuId: v4(),
		menuName: "Moctail",
		menuPrice: "IDR 20k",
		menuAddition: ["Strawbery", "Kiwi", "Lyhcee"],
		menuImage: require("./MenusImage/Moctail.png"),
		menuColor: "#fad2e1",
	},

	{
		menuId: v4(),
		menuName: "Americano",
		menuPrice: "IDR 17k",
		menuAddition: ["Original", "Strawberry", "Rum"],
		menuImage: require("./MenusImage/Americano.png"),
		menuColor: "#5b5b5b",
	},
	{
		menuId: v4(),
		menuName: "Mocha",
		menuPrice: "IDR 18k",
		menuAddition: [],
		menuImage: require("./MenusImage/Mocca.png"),
		menuColor: "#CFBBA8",
	},
	{
		menuId: v4(),
		menuName: "Syukur Nikmat",
		menuPrice: "IDR 18k",
		menuAddition: [],
		menuImage: require("./MenusImage/EsKopi.png"),
		menuColor: "#cae2bc",
	},
];

export const kokaMenuNonCoffe = [
	{
		menuId: v4(),
		menuName: "Chocolate",
		menuPrice: "IDR 16k",
		menuAddition: ["Original", "Hazelnut", "Rum", "Vanilla", "Caramel"],
		menuImage: require("./MenusImage/Choclate.png"),
		menuColor: "#6c584c",
	},
	{
		menuId: v4(),
		menuName: "Yakult",
		menuPrice: "IDR 17k",
		menuAddition: ["Strawbery", "Kiwi", "Lyhcee"],
		menuImage: require("./MenusImage/Yakult.png"),
		menuColor: "#e9e6ff",
	},
	{
		menuId: v4(),
		menuName: "Charcoal",
		menuPrice: "IDR 20k",
		menuAddition: [],
		menuImage: require("./MenusImage/Charcoal.png"),
		menuColor: "#d6d2d2",
	},
	{
		menuId: v4(),
		menuName: "Orange Mango",
		menuPrice: "IDR 18k",
		menuAddition: [],
		menuImage: require("./MenusImage/OrangeMango.png"),
		menuColor: "#f1844b",
	},

	{
		menuId: v4(),
		menuName: "Oreo Milky",
		menuPrice: "IDR 18k",
		menuAddition: [],
		menuImage: require("./MenusImage/Oreo.png"),
		menuColor: "#424242",
	},

	{
		menuId: v4(),
		menuName: "Red Velvet",
		menuPrice: "IDR 17k",
		menuAddition: [],
		menuImage: require("./MenusImage/RedVelvet.png"),
		menuColor: "#ffa69e",
	},
];

export const menuCoca = [
	{
		menuId: v4(),
		menuName: "Classic Chocolate",
		menuPrice: "IDR 8k",
		menuColor: "#6c584c",
		menuImage: require("./MenusImage/CookiesChocolateClassic.png"),
		menuAddition: [],
	},
	{
		menuId: v4(),
		menuName: "Cookie Monster",
		menuPrice: "IDR 10k",
		menuColor: "#CFBBA8",
		menuImage: require("./MenusImage/CookiesMonster.png"),
		menuAddition: [],
	},

	{
		menuId: v4(),
		menuName: `Cookie Cream Oreo`,
		menuPrice: "IDR 10k",
		menuColor: "#424242",
		menuImage: require("./MenusImage/CookiesOreo.png"),
		menuAddition: [],
	},
	{
		menuId: v4(),
		menuName: "Red Velvet",
		menuPrice: "IDR 10k",
		menuColor: "#ffa69e",
		menuImage: require("./MenusImage/CookiesRedVelvet.png"),
		menuAddition: [],
	},
	{
		menuId: v4(),
		menuName: "Cookies Charcoal",
		menuPrice: "IDR 10k",
		menuColor: "#d6d2d2",
		menuImage: require("./MenusImage/CookiesCharcoal.png"),
		menuAddition: [],
	},
];

export const menuLowcost = [
	{
		menuId: v4(),
		menuName: "Gunung Tilu Natural",
		menuSub: "Sigararautang, Ateng Pucuk Coklat",
		menuPrice: "IDR 70k/ 200gr",
		menuAddition: ["\u00A0", "Filter"],
		menuImage: require("./MenusImage/GunungTiluNatural.png"),
		menuColor: "#705a44",
	},
	{
		menuId: v4(),
		menuName: "Arjasari Honey",
		menuSub: "Sigararutang, Timtim, Typica, Kartika",
		menuPrice: "IDR 70k/ 200gr",
		menuAddition: ["\u00A0", "Filter"],
		menuImage: require("./MenusImage/ArjasariHoney.png"),
		menuColor: "#88725c",
	},
	{
		menuId: v4(),
		menuName: "Puntang Natural",
		menuSub: "Typica, Sigararutang, Lini S",
		menuPrice: "IDR 70k/ 200gr",
		menuAddition: ["\u00A0", "Filter"],
		menuImage: require("./MenusImage/PuntangNatural.png"),
		menuColor: "#7c6650",
	},
	{
		menuId: v4(),
		menuName: "Robusta",
		menuPrice: "IDR 95k/ 1kg",
		menuAddition: ["Espresso"],
		menuImage: require("./MenusImage/RobustaEspresso.png"),
		menuColor: "#947e68",
	},
	{
		menuId: v4(),
		menuName: "Blend 60/40",
		menuPrice: "IDR 150k/ 1kg",
		menuAddition: ["Espresso"],
		menuImage: require("./MenusImage/BlendEspresso.png"),
		menuColor: "#9d8872",
	},
	{
		menuId: v4(),
		menuName: "Arabica Blend (South)",
		menuPrice: "IDR 230k/ 1kg",
		menuAddition: ["Espresso"],
		menuImage: require("./MenusImage/ArabicaBlend(South).png"),
		menuColor: "#a6917b",
	},
];
